<template>
    <div class="login-container">
        <div class="row justify-content-center">
            <div class="col-md-8 rounded-0">
                <div class="card card-default rounded-0 border-0">
                    <div class="card-header">LOGIN</div>

                    <div class="card-body rounded-0 p-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-4 p-0 login-img d-flex flex-column text-center" style="justify-content: center; align-items: center;">
                                    <img src="/images/machship-logo.svg" alt="MachShip" style="max-width: 260px; height: auto;">
                                    <h5 style="color: #004AAD;">Integrations</h5>
                                </div>
                                <div class="col-lg-8 rounded-0 bg-white">
                                    <form method="POST" action="/login">
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <input id="email" type="email" class="form-control rounded-0" placeholder="Email" v-model="email" required autofocus>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <input id="password" type="password" class="form-control rounded-0" placeholder="Password" v-model="password" required>
                                            </div>
                                        </div>

                                        <div class="form-group row ">
                                            <div class="col-md-12">
                                                <button type="submit" class="btn btn-mach-primary rounded-0" @click="handleSubmit">
                                                    Login
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-snackbar
            v-model="isShow"
            color="#d55"
            :multi-line="true"
            :center="true"
            :timeout="3000"
            :top="true">
            {{ message }}
            <v-btn dark text @click="isShow = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>

    export default {
        data(){
            return {
                email : "",
                password : "",
                isShow: false,
                message: "",
                referrer: null
            }
        },
        methods : {
            handleSubmit(e){
                e.preventDefault()

                if (this.password.length > 0) {
                    axios.post('api/auth/token', {
                        withCredentials: true,
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        }
                        },{
                        auth: {
                            username: this.email,
                            password: this.password
                        }
                    }).then((response) => {
                        if (response.data.two_factor_required) {
                            // Redirect to verification page with temp token
                            this.$router.push({
                                path: '/verify',
                                query: {
                                    temp_token: response.data.temp_token,
                                    referrer: this.referrer || '/'
                                }
                            });
                        } else {
                            const newToken = response.data.data.attributes.token;
                            this.handleSuccessfulLogin(newToken);
                        }
                    }).catch(err => {
                        this.isShow = true
                        if (err.response.status == 401) {
                            this.message = "Incorrect login credentials, Please try again."
                        } else {
                            this.message = this.getErrors(err)
                        }
                    });

                }
            },

            handleSuccessfulLogin(token) {
                localStorage.setItem('jwt', token);
                this.$store.dispatch('updateToken', token);
                if (localStorage.getItem('jwt') != null) {
                    window.location.href = this.referrer ?? "/";
                }
            }
        },

        mounted() {
            const { query } = this.$route;
            if (query && query.refs) {
                this.referrer = decodeURIComponent(query.refs)
            }
        },
        beforeRouteEnter (to, from, next) {
            if (localStorage.getItem('jwt')) {
                return next('dashboard');
            }

            next();
        },

    }
</script>